import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "errorText", "name", "onChange", "modifyValue", "showValidationErrorOnChange"];
import React from 'react';
import BaseInput from './BaseInput';
import { useExtendedField } from '../../../../hooks';
var NUMBER_TYPES = {
  tel: {
    props: {
      type: 'tel',
      autoComplete: 'tel',
      format: '(###) ###-####'
    },
    modifyValue: function modifyValue(val) {
      return val.replace(/([()\-\s])/g, '');
    }
  },
  ssn: {
    props: {
      format: '###-##-####'
    }
  },
  ssnLastFour: {
    props: {
      format: '####'
    }
  },
  currency: {
    props: {
      prefixDisplay: '$',
      thousandSeparator: ',',
      decimalScale: 0,
      allowNegative: false,
      type: 'text'
    },
    modifyValue: function modifyValue(val) {
      return parseFloat(val.replace(/,/g, ''));
    }
  },
  date: {
    props: {
      type: 'text',
      format: '##/##/####'
    },
    modifyValue: function modifyValue(val) {
      return val.replace(/(\d{2})(\d{2})(\d{4})/, function (_, p1, p2, p3) {
        return [p1, p2, p3].join('/');
      });
    }
  }
};
var STRING_TYPES = {
  email: {
    props: {
      autoComplete: 'email'
    }
  }
};

var Input = function Input(_ref) {
  var _NUMBER_TYPES$type;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      errorText = _ref.errorText,
      name = _ref.name,
      onChange = _ref.onChange,
      modifyValue = _ref.modifyValue,
      showValidationErrorOnChange = _ref.showValidationErrorOnChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var stringProps = STRING_TYPES[type] ? _extends({
    type: 'text'
  }, STRING_TYPES[type].props) : {
    type: type
  };
  var typeProps = NUMBER_TYPES[type] ? _extends({
    type: 'text',
    useNumberFormat: true
  }, NUMBER_TYPES[type].props) : stringProps;

  var _useExtendedField = useExtendedField({
    name: name
  }, {
    onChange: onChange,
    errorText: errorText,
    modifyValue: modifyValue || ((_NUMBER_TYPES$type = NUMBER_TYPES[type]) === null || _NUMBER_TYPES$type === void 0 ? void 0 : _NUMBER_TYPES$type.modifyValue),
    showValidationErrorOnChange: showValidationErrorOnChange
  }),
      _useExtendedField2 = _slicedToArray(_useExtendedField, 2),
      formikFieldConfig = _useExtendedField2[0],
      error = _useExtendedField2[1].errorText;

  return /*#__PURE__*/React.createElement(BaseInput, _extends({
    errorText: error
  }, formikFieldConfig, typeProps, rest));
};

export default Input;